export default __webpack_public_path__ + "static/media/ms-excel.d73b2655.svg";